import React, { useCallback, useLayoutEffect, useMemo, useState } from 'react'

const SCREEN_XS = 480
const SCREEN_SM = 768
const SCREEN_MD = 992
const SCREEN_LG = 1200

interface ResponsiveProps {
  xs?: React.ReactElement
  sm?: React.ReactElement
  md?: React.ReactElement
  lg?: React.ReactElement
  minWidth?: number
  maxWidth?: number
  children?: React.ReactNode
}

const Responsive = ({ xs, sm, md, lg, minWidth, maxWidth, children }: ResponsiveProps) => {
  const [width, setWidth] = useState(window.innerWidth || 0)

  const updateSize = useCallback(() => {
    setWidth(window.innerWidth)
  }, [])

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [updateSize])

  const component = useMemo(() => {
    let component: React.ReactNode = null

    if (maxWidth || minWidth) {
      if (minWidth && width < minWidth) {
        return null
      }
      if (maxWidth && width > maxWidth) {
        return null
      }
      return children
    }

    if (width < SCREEN_XS) {
      component = xs
    } else if (width < SCREEN_SM) {
      component = sm
    } else if (width < SCREEN_MD) {
      component = md
    } else if (width < SCREEN_LG) {
      component = lg
    }

    return component || children
  }, [children, xs, sm, md, lg, maxWidth, minWidth, width])

  return <>{component}</>
}

export default Responsive
